import React, { useContext, useState } from 'react'
import "./Shop.css"
import { NavLink } from 'react-router-dom';
import { AuthContext } from './Context';
function Sofas() {

 const furnitureData=useContext(AuthContext)
 
 
 
 


    const [furniture,setFurniture]=useState("All")
    const [material,setMaterial]=useState("All Materials")
    const [size,setSize]=useState("All Sizes")

    const sofaArray=furnitureData.filter(furniture=>furniture.category.toLocaleLowerCase().includes("sofa"))

    const sofaArrayResults=sofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))
    const leatherSofaArray=sofaArray.filter(furniture=>furniture.material.toLocaleLowerCase().includes("leather"))

    const leatherSofaArrayResults=leatherSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))
    const fabricSofaArray=sofaArray.filter(furniture=>furniture.material.toLocaleLowerCase().includes("fabric"))

    const fabricSofaArrayResults=fabricSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))
    const velvetSofaArray=sofaArray.filter(furniture=>furniture.material.toLocaleLowerCase().includes("velvet"))
const velvetSofaArrayResults=velvetSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))
    
const leather2seaterSofaArray=leatherSofaArray.filter(furniture=>furniture.seaters===2)
const leather2seaterSofaArrayResults=leather2seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))

const leather1seaterSofaArray=leatherSofaArray.filter(furniture=>furniture.seaters===1)
const leather1seaterSofaArrayResults=leather1seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))

const leather3seaterSofaArray=leatherSofaArray.filter(furniture=>furniture.seaters===3)
const leather3seaterSofaArrayResults=leather3seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))

const leather4seaterSofaArray=leatherSofaArray.filter(furniture=>furniture.seaters===4)
const leather4seaterSofaArrayResults=leather4seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))

const leather5seaterSofaArray=leatherSofaArray.filter(furniture=>furniture.seaters===5)
const leather5seaterSofaArrayResults=leather5seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))
const leather7seaterSofaArray=leatherSofaArray.filter(furniture=>furniture.seaters===7)
const leather7seaterSofaArrayResults=leather7seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))

const velvet2seaterSofaArray=velvetSofaArray.filter(furniture=>furniture.seaters===2)
const velvet2seaterSofaArrayResults=velvet2seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))
    const velvet1seaterSofaArray=velvetSofaArray.filter(furniture=>furniture.seaters===1)
const velvet1seaterSofaArrayResults=velvet1seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))

    const velvet7seaterSofaArray=velvetSofaArray.filter(furniture=>furniture.seaters===7)
const velvet7seaterSofaArrayResults=velvet7seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))

const velvetseaterSofaArray=velvetSofaArray.filter(furniture=>furniture.seaters===1)
const velvetseaterSofaArrayResults=velvetseaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))


const velvet3seaterSofaArray=velvetSofaArray.filter(furniture=>furniture.seaters===3)
const velvet3seaterSofaArrayResults=velvet3seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))


const velvet4seaterSofaArray=velvetSofaArray.filter(furniture=>furniture.seaters===4)
const velvet4seaterSofaArrayResults=velvet4seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))


const velvet5seaterSofaArray=velvetSofaArray.filter(furniture=>furniture.seaters===5)
const velvet5seaterSofaArrayResults=velvet5seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))



const fabric2seaterSofaArray=fabricSofaArray.filter(furniture=>furniture.seaters===2)
const fabric2seaterSofaArrayResults=fabric2seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))


const fabric1seaterSofaArray=fabricSofaArray.filter(furniture=>furniture.seaters===1)
const fabric1seaterSofaArrayResults=fabric1seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))

const fabric3seaterSofaArray=fabricSofaArray.filter(furniture=>furniture.seaters===3)
const fabric3seaterSofaArrayResults=fabric3seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))

const fabric4seaterSofaArray=fabricSofaArray.filter(furniture=>furniture.seaters===4)
const fabric4seaterSofaArrayResults=fabric4seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))

const fabric5seaterSofaArray=fabricSofaArray.filter(furniture=>furniture.seaters===5)
const fabric5seaterSofaArrayResults=fabric5seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))

const fabric7seaterSofaArray=fabricSofaArray.filter(furniture=>furniture.seaters===7)
const fabric7seaterSofaArrayResults=fabric7seaterSofaArray.map((item)=>(
               <div class="morara-card">
        <NavLink to={`/products/${item.id}`}>
        
        {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
      <img
        src={item.image} alt={item.name}
        class="morara-card-img"
      />
    
      <h3 class="morara-card-title">{item.name}</h3>
      <p class="morara-card-desc">
        {item.description}
      </p>
    
      <div class="morara-subimages">
    
        
    
        {item.subimages.map((img, index) => (
      <img key={index} src={img} alt={item.name} />
    ))}
    
    
       
      </div>
    <div className='morara-actions'>
      <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                          style: "currency",
                          currency: "KES",
                          minimumFractionDigits: 0,
                        }).format(item.price)}</p>
      <button class="morara-btn">View</button>
      </div>
    </NavLink>
    
    </div> 
    
    ))






  return (
    <>
     
  <header class="morara-header">
    <h1 class="morara-title">Morara Premium Sofas</h1>
    <p class="morara-subtitle"> Elegant Sofas • Home Comfort</p>
  </header>

  <section class="morara-filter-bar">
  <div class="morara-dropdown">
    <div class="morara-dropdown-selected" id="categorySelected" onClick={()=>{setFurniture("All")}}>{furniture}</div>
    <div class="morara-dropdown-options" id="categoryOptions">
      <div data-value="sofa" onClick={()=>{setFurniture("Sofas")}} className={furniture==="Sofas"?"furniture-active":""}>Sofas</div>
    </div>
  </div>

  <div class="morara-dropdown">
    <div class="morara-dropdown-selected" id="materialSelected">{material}</div>
    <div class="morara-dropdown-options" id="materialOptions">
      <div data-value="all" onClick={()=>{setMaterial("All Materials")}} className={material==="All Materials"?"furniture-active":""}> All Materials</div>
      <div data-value="leather" onClick={()=>{setMaterial("Leather")}} className={material==="Leather"?"furniture-active":""}>Leather</div>
      <div data-value="fabric" onClick={()=>{setMaterial("Fabric")}} className={material==="Fabric"?"furniture-active":""}>Fabric</div>
      <div data-value="velvet" onClick={()=>{setMaterial("Velvet")}} className={material==="Velvet"?"furniture-active":""}>Velvet</div>
    </div>
  </div>

  <div class="morara-dropdown">
    <div class="morara-dropdown-selected" id="seaterSelected">{size}</div>
    <div class="morara-dropdown-options" id="seaterOptions">
      <div data-value="all" onClick={()=>{setSize("All Sizes")}} className={material==="All Sizes"?"furniture-active":""}>All Sizes</div>
      <div data-value="3" onClick={()=>{setSize("1seater")}} className={material==="1seater"?"furniture-active":""}>1 Seater</div>
      <div data-value="3" onClick={()=>{setSize("2seater")}} className={material==="2seater"?"furniture-active":""}>2 Seater</div>

      <div data-value="3" onClick={()=>{setSize("3seater")}} className={material==="3seater"?"furniture-active":""}>3 Seater</div>
      <div data-value="5" onClick={()=>{setSize("5seater")}} className={material==="5seater"?"furniture-active":""}>5 Seater</div>
      <div data-value="queen" onClick={()=>{setSize("7seater")}} className={material==="Queen"?"furniture-active":""}>7 seater</div>
    </div>
  </div>
</section>

  <main id="moraraProducts" class="morara-products">
    
{material==="All Materials" && size==="All Sizes" && sofaArrayResults}
{material==="All Materials" && size==="1seater" && sofaArrayResults}
{material==="All Materials" && size==="2seater" && sofaArrayResults}
{material==="All Materials" && size==="3seater" && sofaArrayResults}
{material==="All Materials" && size==="5seater" && sofaArrayResults}
{material==="All Materials" && size==="7seater" && sofaArrayResults}

{material==="Leather" && size==="All Sizes" && leatherSofaArrayResults}
{material==="Leather" && size==="2seater" && leather2seaterSofaArrayResults}
{material==="Leather" && size==="1seater" && leather1seaterSofaArrayResults}
{material==="Leather" && size==="3seater" && leather3seaterSofaArrayResults}
{material==="Leather" && size==="5seater" && leather5seaterSofaArrayResults}
{material==="Leather" && size==="7seater" && leather7seaterSofaArrayResults}

{material==="Fabric" && size==="All Sizes" && fabricSofaArrayResults}
{material==="Fabric" && size==="2seater" && fabric2seaterSofaArrayResults}
{material==="Fabric" && size==="1seater" && fabric1seaterSofaArrayResults}
{material==="Fabric" && size==="3seater" && fabric3seaterSofaArrayResults}
{material==="Fabric" && size==="5seater" && fabric5seaterSofaArrayResults}
{material==="Fabric" && size==="7seater" && fabric7seaterSofaArrayResults}


{material==="Velvet" && size==="All Sizes" && velvetSofaArrayResults}
{material==="Velvet" && size==="2seater" && velvet2seaterSofaArrayResults}
{material==="Velvet" && size==="1seater" && velvet1seaterSofaArrayResults}
{material==="Velvet" && size==="3seater" && velvet3seaterSofaArrayResults}
{material==="Velvet" && size==="5seater" && velvet5seaterSofaArrayResults}
{material==="Velvet" && size==="7seater" && velvet7seaterSofaArrayResults}
</main>
 


    </>
  )
}

export default Sofas
